// List from Ads team for adschedule ids for auto play and click to play in that order
const BRAND_AD_SCHEDULE_ID_LIST = {
  allas: {
    autoPlay: 'a4kkgt0P',
    clickToPlay: '0XDonXQi',
  },
  elle: {
    autoPlay: 'RBpAHqAL',
    clickToPlay: 'hpHCqkob',
  },
  femina: {
    autoPlay: 'uBH5g2Sr',
    clickToPlay: 'VYCGmwt4',
  },
  mabra: {
    autoPlay: 'UDNmLZsj',
    clickToPlay: 'oP4lk47h',
  },
  residence: {
    autoPlay: 'OhFmmo3F',
    clickToPlay: 'ib9PwBrj',
  },
  recept: {
    autoPlay: 'Okw1o1NG',
    clickToPlay: 'aHAyNyyp',
  },
  motherhood: {
    autoPlay: 'ZUkc4M5g',
    clickToPlay: 'uES06Oub',
  },
  hant: {
    autoPlay: 'DrX1nVjT',
    clickToPlay: 'DZo5Gx0b',
  },
  svenskdam: {
    autoPlay: 'DfBHqYZx',
    clickToPlay: 'JcHd23Vg',
  },
};

export const getBrandAdScheduleId = (brand, variant = 'autoPlay') =>
  BRAND_AD_SCHEDULE_ID_LIST[brand] ? BRAND_AD_SCHEDULE_ID_LIST[brand][variant] : null;
